export default __webpack_public_path__ + "static/media/edit-table.d19b4626.svg";